/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PasswordChangeError {
    WEAK_PASSWORD = 'WeakPassword',
}
